import LoadingDog from '../../../components/LoadingDog';

export default { Loading: { component: LoadingDog } };
